'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dictionary = function Dictionary(map) {
  var _this = this;

  _classCallCheck(this, Dictionary);

  this.getLabel = function (value) {
    return _this.map[value];
  };

  this.getLabels = function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return values.map(_this.getLabel).join(', ');
  };

  this.map = map;

  this.values = (0, _keys2.default)(map);
  this.labels = (0, _values2.default)(map);

  this.options = this.values.map(function (value) {
    return {
      value: value,
      label: map[value]
    };
  });
};

exports.default = Dictionary;